import styled from 'styled-components/macro';

export const ErrorMsg = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LabelWrapper = styled.div`
  text-align: center;
  font-size: 14px;
  color: #808080;
  padding: 10px;
  border: 2px solid #808080;
  border-radius: 9px;
  margin-bottom: 30px;

  & icon {
    padding-right: 5px;
    top: 2px;
    color: #808080;
  }
`;

export const ErrorText = styled.h1`
  margin: auto;
  text-align: center;
  color: #d1d1d1;
  font-size: 30px;
  font-family: 'Lato-Light', sans-serif;
  padding-bottom: 100px;
`;

export const Button = styled.button`
  background-color: ${(props) => (props.disabled ? '#545454' : '#44b1df')};
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: #545454;
  }
`;

export const Page = styled.div`
  margin: 4rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0 0 0;
`;
